module.exports = __webpack_public_path__ + "assets/img/halkbank@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/halkbank@2x.png
// module id = 132
// module chunks = 0